import { Controller } from 'react-hook-form';
import classNames from 'classnames';
import { IconFont } from '../../../IconFont';
import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import type { ITag } from '@/services/workbench';
import type { IFormValue } from '../../type';
import './index.less';

export const CheckboxGroup: FC<{
  name: keyof IFormValue;
  control: Control<IFormValue, any>;
  options: ITag[];
}> = (props) => {
  // props
  const { name, control, options } = props;
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: true }}
      render={({ field }) => {
        return (
          <section className="flex flex-wrap gap-3 justify-between">
            {options.map((option) => {
              const { id, name } = option;
              const checked = field.value === id;

              return (
                <section
                  className={classNames(
                    'relative box-border w-[188px] h-[76px] bg-[#F4F7FE] border-2 border-[transparent] rounded-md',
                    { 'bg-white border-primary': checked },
                  )}
                  key={id}
                >
                  <label
                    className={classNames(
                      'relative inline-flex items-center gap-3 w-full h-full px-6 text-base text-secondary-1',
                      { 'font-medium text-main': checked },
                    )}
                  >
                    <input
                      type="checkbox"
                      className="absolute top-0 right-0 bottom-0 left-0 opacity-0"
                      value={id}
                      checked={checked}
                      onChange={() => {
                        field.onChange(id);
                      }}
                    />
                    {option.type === 1 ? (
                      <IconFont
                        className="text-3xl"
                        type={option.active_icon}
                      />
                    ) : (
                      <img
                        className="w-10"
                        src={checked ? option.active_icon : option.icon}
                        alt="icon"
                      />
                    )}
                    <span>{name}</span>
                  </label>
                  <span
                    className={classNames(
                      'cg-checked absolute right-0 bottom-0 w-[22px] h-[18px] bg-primary rounded-[8px_0_4px_0]',
                      { hidden: !checked },
                      { 'inline-block': checked },
                    )}
                  ></span>
                </section>
              );
            })}
          </section>
        );
      }}
    />
  );
};
